import defaultClient from '@/plugins/axios/defaultClient'

export default {
  getTwoFactorAuthCode({ uuid }) {
    return defaultClient.post(`/mall-limits/${uuid}/request-two-factor-auth`)
  },
  /**
   * 인증문자 확인
   * @param {{
   * "otp": "333333",
   * } otp
   * @returns
   */
  postTwoFactorAuth(mallLimit, otp) {
    return defaultClient.post(`/mall-limits/${mallLimit.uuid}/two-factor-auth`, { otp })
  },
  getMallLimits() {
    return defaultClient.get('/mall-limits')
  },
  getMallLimitsDetail({ uuid }) {
    return defaultClient.get(`/mall-limits/${uuid}`)
  },
}
